import React from "react";
import { StyledButton } from "../../../HeaderStyles";
import BuildButton from "../../../build-button/BuildButton";
import PublishButton from "../../../publish-button/PublishButton";
import useActionButton from "./ActionButton.hook";

const ActionButton = () => {
  const { showLoadingPlaceholder, isBuildDisplayed } = useActionButton();

  if (showLoadingPlaceholder) {
    return <StyledButton data-testid="action-button-loading" loading variant="outlined" sx={{ width: 103, height: 36 }} />;
  }

  if (isBuildDisplayed) {
    return <BuildButton />;
  }

  return <PublishButton />;
};

export default ActionButton;
